module.exports = __webpack_public_path__ + "img/icon-trash.d53f72d2.svg";